
// // import React, { useMemo, useState } from "react";
// // import { Card, Row, Col, Typography, Tag, Button, Select } from "antd";
// // import {
// //   ThunderboltOutlined,
// //   EnvironmentOutlined,
// //   CloseCircleOutlined,
// //   ReloadOutlined,
// //   GlobalOutlined,
// //   HomeOutlined,
// //   ExclamationCircleOutlined,
// //   // All stage icons
// //   FileTextOutlined,
// //   SafetyCertificateOutlined,
// //   DollarOutlined,
// //   TeamOutlined,
// //   CheckCircleOutlined,
// //   ContactsOutlined,
// //   KeyOutlined,
// //   SearchOutlined,
// //   DesktopOutlined,
// //   BankOutlined,
// //   SolutionOutlined,
// //   AuditOutlined,
// //   FileProtectOutlined,
// //   DownloadOutlined,
// // } from "@ant-design/icons";

// // import {
// //   PieChart,
// //   Pie,
// //   Cell,
// //   BarChart,
// //   Bar,
// //   XAxis,
// //   YAxis,
// //   CartesianGrid,
// //   Tooltip as RechartsTooltip,
// //   ResponsiveContainer,
// // } from "recharts";

// // import useDashboardMetrics from "../../hooks/dashboard/useDashboardMetrics";
// // import useDashboardExport from "../../hooks/dashboard/useDashboardExport";
// // import useOrgHierarchy from "../../hooks/projects/useOrgHierarchy";
// // import "./Dashboard.css";

// // const { Text } = Typography;

// // // Palette
// // const C = {
// //   green: "#1a9e5c",
// //   greenSoft: "#e8f6ee",
// //   blue: "#2e6fdb",
// //   blueSoft: "#eaf1fd",
// //   orange: "#e07b1a",
// //   orangeSoft: "#fdf1e2",
// //   red: "#d0392b",
// //   redSoft: "#fbe9e7",
// //   gray: "#9aa2ac",
// //   graySoft: "#eef0f2",
// // };

// // const STAGE_ICONS = [
// //   EnvironmentOutlined,
// //   FileTextOutlined,
// //   SafetyCertificateOutlined,
// //   DollarOutlined,
// //   TeamOutlined,
// //   CheckCircleOutlined,
// //   ContactsOutlined,
// //   KeyOutlined,
// //   SearchOutlined,
// //   DesktopOutlined,
// //   BankOutlined,
// //   SolutionOutlined,
// //   AuditOutlined,
// //   FileProtectOutlined,
// //   HomeOutlined,
// // ];

// // const fmtPct = (n) => `${(n ?? 0).toFixed(1)}%`;

// // const annotateStages = (stages = [], delaySummary = {}) => {
// //   const lastReachedIdx = stages.reduce((last, s, i) => (s.count > 0 ? i : last), -1);

// //   return stages.map((s, idx) => {
// //     let status = "not-started";
// //     if (s.count > 0) {
// //       status = s.percentage === 100 ? "completed" : "in-progress";
// //     }
// //     if (idx === lastReachedIdx && delaySummary) {
// //       if (delaySummary.critical_red_total?.count > 0) status = "critical";
// //       else if (delaySummary.delayed_orange_total?.count > 0) status = "at-risk";
// //     }
// //     return { ...s, status };
// //   });
// // };

// // const STATUS_STYLE = {
// //   completed: { bg: C.greenSoft, fg: C.green, label: "Completed" },
// //   "in-progress": { bg: C.blueSoft, fg: C.blue, label: "In Progress" },
// //   "at-risk": { bg: C.orangeSoft, fg: C.orange, label: "Delayed" },
// //   critical: { bg: C.redSoft, fg: C.red, label: "Critical" },
// //   "not-started": { bg: C.graySoft, fg: C.gray, label: "Yet to Start" },
// // };

// // const MiniDivider = () => <div className="mini-divider" />;

// // const StatCircleCard = ({ icon, label, value, note, accent }) => (
// //   <Card className="stat-card" bordered>
// //     <div className="stat-card-row">
// //       <div className="stat-icon-circle" style={{ background: `${accent}1a`, color: accent }}>
// //         {icon}
// //       </div>
// //       <div className="stat-card-body">
// //         <Text className="stat-label">{label}</Text>
// //         <div className="stat-value-row">
// //           <span className="stat-value">{value}</span>
// //         </div>
// //         {note && <Text className="stat-note">{note}</Text>}
// //       </div>
// //     </div>
// //   </Card>
// // );

// // const PieLegendCard = ({ title, data, total, extra }) => (
// //   <Card className="chart-card pie-card" title={<span className="card-title">{title}</span>} extra={extra}>
// //     <div className="pie-card-flex">
// //       <ResponsiveContainer width="55%" height={230}>
// //         <PieChart>
// //           <Pie data={data} dataKey="value" nameKey="name" innerRadius={55} outerRadius={95} paddingAngle={2}>
// //             {data.map((entry, i) => (
// //               <Cell key={i} fill={entry.color} />
// //             ))}
// //           </Pie>
// //           <RechartsTooltip />
// //         </PieChart>
// //       </ResponsiveContainer>
// //       <div className="pie-legend-list">
// //         {data.map((d, i) => (
// //           <div className="pie-legend-item" key={i}>
// //             <span className="legend-dot" style={{ background: d.color }} />
// //             <span className="pie-legend-name">{d.name}</span>
// //             <span className="pie-legend-value">
// //               {d.displayValue ?? d.value} ({fmtPct(d.percentage)})
// //             </span>
// //           </div>
// //         ))}
// //         <MiniDivider />
// //         <div className="pie-legend-total">
// //           <span>Total</span>
// //           <span className="pie-legend-total-value">{total}</span>
// //         </div>
// //       </div>
// //     </div>
// //   </Card>
// // );

// // const StageTracker = ({ title, stages }) => (
// //   <Card className="chart-card tracker-card" title={<span className="card-title">{title}</span>}>
// //     <div className="stage-chevron-row">
// //       {stages.map((s, i) => {
// //         const Icon = STAGE_ICONS[i % STAGE_ICONS.length];
// //         const style = STATUS_STYLE[s.status];
// //         return (
// //           <div className="stage-chip" key={i} style={{ background: style.bg }}>
// //             <div className="stage-chip-icon" style={{ color: style.fg }}>
// //               <Icon />
// //             </div>
// //             <div className="stage-chip-label">
// //               {s.stage_num}. {s.stage_name}
// //             </div>
// //             <div className="stage-chip-value" style={{ color: style.fg }}>
// //               {s.count} ({fmtPct(s.percentage)})
// //             </div>
// //           </div>
// //         );
// //       })}
// //     </div>
// //     <div className="tracker-legend">
// //       {Object.keys(STATUS_STYLE).map((k) => (
// //         <span key={k} className="tracker-legend-item">
// //           <span
// //             className="legend-dot"
// //             style={{ background: STATUS_STYLE[k].bg, border: `1px solid ${STATUS_STYLE[k].fg}` }}
// //           />
// //           {STATUS_STYLE[k].label}
// //         </span>
// //       ))}
// //     </div>
// //   </Card>
// // );

// // /** Legend row matching the same visual style as StageTracker's tracker-legend */
// // const ChartLegend = ({ items }) => (
// //   <div className="tracker-legend chart-legend">
// //     {items.map((it) => (
// //       <span key={it.name} className="tracker-legend-item">
// //         <span className="legend-dot" style={{ background: it.color, border: `1px solid ${it.color}` }} />
// //         {it.name}
// //       </span>
// //     ))}
// //   </div>
// // );

// // /**
// //  * Generic horizontal stacked bar chart card.
// //  * `data` = [{ label: 'Milestone / Stage name', <barKey>: number, ... }]
// //  * `bars` = [{ dataKey, name, color }]
// //  * `minRows` lets sibling cards in the same row share one common chart height.
// //  */
// // const HorizontalStackedBarCard = ({ title, data, bars, barSize = 14, minRows }) => {
// //   const rowCount = Math.max(data.length, minRows || 0);
// //   const height = Math.max(rowCount * 40 + 40, 200);
// //   return (
// //     <Card className="chart-card stacked-hbar-card" title={<span className="card-title">{title}</span>}>
// //       <ResponsiveContainer width="100%" height={height}>
// //         <BarChart
// //           data={data}
// //           layout="vertical"
// //           margin={{ top: 4, right: 16, left: 4, bottom: 4 }}
// //           barSize={barSize}
// //           barGap={2}
// //         >
// //           <CartesianGrid strokeDasharray="3 3" horizontal={false} />
// //           <XAxis
// //             type="number"
// //             allowDecimals={false}
// //             label={{
// //               value: "Number of Projects",
// //               position: "insideBottom",
// //               offset: -2,
// //               style: {
// //                 fontSize: 12,
// //                 fontWeight: 600,
// //                 fill: "#374151",
// //               },
// //             }}
// //           />

// //           <YAxis
// //             type="category"
// //             dataKey="label"
// //             width={150}
// //             tick={{
// //               fontSize: 11,
// //               fill: "#374151",
// //             }}
// //             label={{
// //               value: "Milestone",
// //               angle: -90,
// //               position: "insideLeft",
// //               style: {
// //                 fontSize: 12,
// //                 fontWeight: 600,
// //                 fill: "#374151",
// //               },
// //             }}
// //           />
// //           <RechartsTooltip />
// //           {bars.map((b) => (
// //             <Bar key={b.dataKey} dataKey={b.dataKey} name={b.name} stackId="a" fill={b.color} radius={[0, 0, 0, 0]} />
// //           ))}
// //         </BarChart>
// //       </ResponsiveContainer>
// //       <ChartLegend items={bars.map((b) => ({ name: b.name, color: b.color }))} />
// //     </Card>
// //   );
// // };

// // const typeLabels = { govt_land: "Govt. Land", midc_land: "MIDC Land", private_land: "Private Land", others: "Others" };
// // const typeColors = { govt_land: C.blue, midc_land: C.green, private_land: C.orange, others: C.gray };

// // const DELAY_BAR_DEFS = [
// //   { dataKey: "on_time", name: "On Time", color: C.green },
// //   { dataKey: "delayed_orange", name: "Delayed", color: C.orange },
// //   { dataKey: "critical_red", name: "Critical", color: C.red },
// // ];

// // const PIPELINE_BAR_DEFS = [
// //   { dataKey: "completed", name: "Completed", color: C.green },
// //   { dataKey: "active_on_time", name: "Active (On Time)", color: C.blue },
// //   { dataKey: "delayed_orange", name: "Delayed", color: C.orange },
// //   { dataKey: "critical_red", name: "Critical", color: C.red },
// //   { dataKey: "not_started", name: "Yet to Start", color: C.gray },
// // ];

// // const ANNUAL_AREA_BAR_DEFS = [
// //   { dataKey: "Govt Land", name: "Govt Land", color: C.blue },
// //   { dataKey: "MIDC Land", name: "MIDC Land", color: C.green },
// //   { dataKey: "Private Land", name: "Private Land", color: C.orange },
// // ];

// // const mapMilestones = (milestones = []) =>
// //   milestones.map((m) => ({
// //     label: m.milestone_step,
// //     on_time: m.on_time?.count || 0,
// //     delayed_orange: m.delayed_orange?.count || 0,
// //     critical_red: m.critical_red?.count || 0,
// //   }));

// // const mapPipelineStages = (stages = []) =>
// //   stages.map((s) => ({
// //     label: `${s.stage_num}. ${s.stage_name}`,
// //     completed: s.completed?.count || 0,
// //     active_on_time: s.active_on_time?.count || 0,
// //     delayed_orange: s.delayed_orange?.count || 0,
// //     critical_red: s.critical_red?.count || 0,
// //     not_started: s.not_started?.count || 0,
// //   }));

// // const ALL_ZONES_VALUE = "__all__";

// // const Dashboard = () => {
// //   const { zonesList, loading: zonesLoading } = useOrgHierarchy();
// //   const [selectedZone, setSelectedZone] = useState(ALL_ZONES_VALUE);
// //   const { downloadReport, exporting } = useDashboardExport();
// //   const zoneNameParam = selectedZone === ALL_ZONES_VALUE ? undefined : selectedZone;
// //   const { metrics, loading, error, fetchMetrics } = useDashboardMetrics(zoneNameParam);

// //   const zoneOptions = useMemo(
// //     () => [
// //       { value: ALL_ZONES_VALUE, label: "All Zones" },
// //       ...zonesList.map((z) => ({ value: z.name, label: z.name })),
// //     ],
// //     [zonesList]
// //   );

// //   const now = useMemo(() => new Date(), []);

// //   const {
// //     kpi_1_portfolio_summary: summary,
// //     kpi_2_in_possession_bifurcation: possessionByType,
// //     kpi_3_not_in_possession_identification_status: idStatus,
// //     kpi_4_most_feasible_land_trifurcation: feasibleByType,
// //     kpi_5_progress_reports,
// //     kpi_6_annual_area_acquired_hectares: annualArea,
// //     kpi_7_horizontal_stacked_delays: stackedDelays,
// //     kpi_8_overall_portfolio_delay: overallDelay,
// //     kpi_9_pipeline_stage_analysis: pipelineAnalysis,
// //   } = metrics || {};

// //   // ---- KPI 2 donut: In-Possession bifurcation by land type ----
// //   const possessionTypeDonutData = useMemo(
// //     () =>
// //       Object.entries(possessionByType || {}).map(([k, v]) => ({
// //         name: typeLabels[k] || k,
// //         value: v.count || 0,
// //         percentage: v.percentage || 0,
// //         color: typeColors[k] || C.gray,
// //       })),
// //     [possessionByType]
// //   );
// //   const possessionTypeTotal = Object.values(possessionByType || {}).reduce((a, v) => a + (v.count || 0), 0);

// //   // ---- KPI 3 donut: Not-in-possession identification status ----
// //   const idStatusLabels = {
// //     not_yet_identified: "Not Yet Identified",
// //     multiple_lands_identified: "Multiple Lands Identified",
// //     most_feasible_land_identified: "Most Feasible Land Identified",
// //   };
// //   const idStatusColors = {
// //     not_yet_identified: C.orange,
// //     multiple_lands_identified: C.blue,
// //     most_feasible_land_identified: C.green,
// //   };
// //   const idStatusDonutData = useMemo(
// //     () =>
// //       Object.entries(idStatus || {}).map(([k, v]) => ({
// //         name: idStatusLabels[k] || k,
// //         value: v.count || 0,
// //         percentage: v.percentage || 0,
// //         color: idStatusColors[k] || C.gray,
// //       })),
// //     [idStatus]
// //   );
// //   const idStatusTotal = Object.values(idStatus || {}).reduce((a, v) => a + (v.count || 0), 0);

// //   if (loading) {
// //     return (
// //       <div className="loading-container">
// //         <div className="loading-spinner" />
// //         <p>Loading Dashboard Metrics...</p>
// //       </div>
// //     );
// //   }

// //   if (error || !metrics) {
// //     return (
// //       <Card className="dashboard-error-card">
// //         <div className="error-content">
// //           <CloseCircleOutlined style={{ fontSize: 48, color: "#ef4444" }} />
// //           <Text type="danger">Failed to load dashboard data.</Text>
// //           <Button onClick={fetchMetrics} type="primary" icon={<ReloadOutlined />}>
// //             Retry
// //           </Button>
// //         </div>
// //       </Card>
// //     );
// //   }

// //   const totalProjects = summary?.total_projects?.count || 0;

// //   const govtStages = annotateStages(kpi_5_progress_reports?.kpi_5_1_govt_land_stages || [], overallDelay?.govt_land);
// //   const midcStages = annotateStages(kpi_5_progress_reports?.kpi_5_2_midc_land_stages || [], overallDelay?.midc_land);
// //   const privateStages = annotateStages(kpi_5_progress_reports?.kpi_5_3_private_land_stages || [], overallDelay?.private_land);

// //   const feasibleTypeRows = Object.entries(feasibleByType || {}).map(([k, v]) => ({
// //     key: k,
// //     label: typeLabels[k] || k,
// //     color: typeColors[k] || C.gray,
// //     ...v,
// //   }));

// //   const delayRows = Object.entries(overallDelay || {}).map(([k, v]) => ({
// //     key: k,
// //     label: typeLabels[k] || k,
// //     ...v,
// //   }));

// //   // ---- KPI 7: horizontal stacked milestone delay charts ----
// //   const govtMilestoneData = mapMilestones(stackedDelays?.kpi_7_1_govt_land_milestones);
// //   const midcMilestoneData = mapMilestones(stackedDelays?.kpi_7_2_midc_land_milestones);
// //   const privateMilestoneData = mapMilestones(stackedDelays?.kpi_7_3_private_land_milestones);
// //   const milestoneRowCount = Math.max(
// //     govtMilestoneData.length,
// //     midcMilestoneData.length,
// //     privateMilestoneData.length
// //   );

// //   // ---- KPI 9: pipeline stage analysis charts ----
// //   const govtPipelineData = mapPipelineStages(pipelineAnalysis?.govt_land_stages);
// //   const midcPipelineData = mapPipelineStages(pipelineAnalysis?.midc_land_stages);
// //   const privatePipelineData = mapPipelineStages(pipelineAnalysis?.private_land_stages);
// //   const pipelineRowCount = Math.max(
// //     govtPipelineData.length,
// //     midcPipelineData.length,
// //     privatePipelineData.length
// //   );

// //   const annualAreaData = Object.entries(annualArea || {}).map(([year, y]) => ({
// //     year,
// //     "Govt Land": y?.govt_land?.area_hectares || 0,
// //     "MIDC Land": y?.midc_land?.area_hectares || 0,
// //     "Private Land": y?.private_land?.area_hectares || 0,
// //   }));

// //   return (
// //     <div className="dashboard-container">
// //       {/* Top Bar */}
// //       <div className="dashboard-topbar">
// //         <div className="brand-block">
// //           <div className="brand-logo">
// //             <ThunderboltOutlined />
// //           </div>
// //           <div>
// //             <Text className="brand-name">Land Acquisition Monitoring Portal</Text>
// //             <div className="brand-sub">Executive Portfolio Review Dashboard</div>
// //           </div>
// //         </div>

// //         <div className="topbar-right">
// //           <Select
// //             className="zone-select"
// //             suffixIcon={<GlobalOutlined />}
// //             value={selectedZone}
// //             onChange={setSelectedZone}
// //             options={zoneOptions}
// //             loading={zonesLoading}
// //             popupMatchSelectWidth={false}
// //           />

// //           <Button className="refresh-btn" type="primary" icon={<ReloadOutlined />} onClick={fetchMetrics}>
// //             Refresh
// //           </Button>
// //           <Button
// //             className="refresh-btn" 
// //             type="default"
// //             icon={<DownloadOutlined />}           // Add this import too
// //             loading={exporting}
// //             onClick={downloadReport}
// //             style={{ marginLeft: 8,color:"#fff" }}
// //           >
// //             Report
// //         </Button>
// //         </div>
// //       </div>

// //       {/* KPI 1 - Summary Cards (4 cards) */}
// //       <Row gutter={[20, 20]} className="section-block" align="stretch">
// //         <Col xs={24} sm={12} md={6}>
// //           <StatCircleCard
// //             icon={<EnvironmentOutlined />}
// //             label="Total Projects"
// //             value={totalProjects}
// //             accent={C.blue}
// //           />
// //         </Col>
// //         <Col xs={24} sm={12} md={6}>
// //           <StatCircleCard
// //             icon={<HomeOutlined />}
// //             label="Projects in Possession"
// //             value={summary?.in_possession?.count || 0}
// //             accent={C.green}
// //           />
// //         </Col>
// //         <Col xs={24} sm={12} md={6}>
// //           <StatCircleCard
// //             icon={<CloseCircleOutlined />}
// //             label="Projects Not in Possession"
// //             value={summary?.not_in_possession?.count || 0}
// //             accent={C.orange}
// //           />
// //         </Col>
// //         <Col xs={24} sm={12} md={6}>
// //           <StatCircleCard
// //             icon={<ExclamationCircleOutlined />}
// //             label="Overall Delayed Projects"
// //             value={summary?.overall_delayed_projects?.count || 0}
// //             accent={C.red}
// //           />
// //         </Col>
// //       </Row>

// //       {/* Donut Charts - KPI 2 & KPI 3 */}
// //       <Row gutter={[20, 20]} className="section-block" align="stretch">
// //         <Col xs={24} lg={12}>
// //           <PieLegendCard
// //             title="In-Possession Land — By Type"
// //             data={possessionTypeDonutData}
// //             total={possessionTypeTotal}
// //           />
// //         </Col>
// //         <Col xs={24} lg={12}>
// //           <PieLegendCard
// //             title="Not-in-Possession — Identification Status"
// //             data={idStatusDonutData}
// //             total={idStatusTotal}
// //           />
// //         </Col>
// //       </Row>

// //       {/* Most Feasible Land (KPI 4) + Overall Portfolio Delay (KPI 8) - single row */}
// //       <Row gutter={[20, 20]} className="section-block" align="stretch">
// //         <Col xs={24} lg={12}>
// //           <Card className="chart-card" title="Most Feasible Land Identified — By Type">
// //             <div className="feasible-list">
// //               {feasibleTypeRows.map((r) => (
// //                 <div className="mini-feasible-row" key={r.key}>
// //                   <span className="legend-dot" style={{ background: r.color }} />
// //                   <span className="mini-feasible-label">{r.label}</span>
// //                   <span className="mini-feasible-value" style={{ color: r.color }}>
// //                     {r.count} ({fmtPct(r.percentage)})
// //                   </span>
// //                 </div>
// //               ))}
// //             </div>
// //           </Card>
// //         </Col>
// //         <Col xs={24} lg={12}>
// //           <Card className="chart-card" title="Overall Portfolio Delay by Land Type">
// //             <div className="delay-table delay-table-compact">
// //               <div className="delay-table-header">
// //                 <span>Land Type</span>
// //                 <span>Avg. Delay (Days)</span>
// //                 <span>On Time</span>
// //                 <span>Delayed</span>
// //                 <span>Critical</span>
// //               </div>
// //               {delayRows.map((r) => (
// //                 <div className="delay-table-row" key={r.key}>
// //                   <span className="project-name">{r.label}</span>
// //                   <span className={r.avg_overall_delay_days > 0 ? "delay-days-bad" : "delay-days-good"}>
// //                     {r.avg_overall_delay_days}
// //                   </span>
// //                   <Tag color="success">{r.on_time_total?.count || 0}</Tag>
// //                   <Tag color="warning">{r.delayed_orange_total?.count || 0}</Tag>
// //                   <Tag color="error">{r.critical_red_total?.count || 0}</Tag>
// //                 </div>
// //               ))}
// //             </div>
// //           </Card>
// //         </Col>
// //       </Row>

// //       {/* Stage Trackers - KPI 5 */}
// //       <Row gutter={[20, 20]} className="section-block">
// //         <Col xs={24}>
// //           <StageTracker title="Government Land Acquisition Progress (8-Stage)" stages={govtStages} />
// //         </Col>
// //       </Row>

// //       <Row gutter={[20, 20]} className="section-block" align="stretch">
// //         <Col xs={24} xl={12}>
// //           <StageTracker title="Private Land Acquisition Progress (6-Stage)" stages={privateStages} />
// //         </Col>
// //         <Col xs={24} xl={12}>
// //           <StageTracker title="MIDC Land Acquisition Progress (5-Stage)" stages={midcStages} />
// //         </Col>
// //       </Row>

// //       {/* KPI 7 - Horizontal Stacked Milestone Delay Charts */}
// //       <Row gutter={[20, 20]} className="section-block" align="stretch">
// //         <Col xs={24} lg={8}>
// //           <HorizontalStackedBarCard
// //             title="Govt. Land — Milestone Delay Status"
// //             data={govtMilestoneData}
// //             bars={DELAY_BAR_DEFS}
// //             minRows={milestoneRowCount}
// //           />
// //         </Col>
// //         <Col xs={24} lg={8}>
// //           <HorizontalStackedBarCard
// //             title="MIDC Land — Milestone Delay Status"
// //             data={midcMilestoneData}
// //             bars={DELAY_BAR_DEFS}
// //             minRows={milestoneRowCount}
// //           />
// //         </Col>
// //         <Col xs={24} lg={8}>
// //           <HorizontalStackedBarCard
// //             title="Private Land — Milestone Delay Status"
// //             data={privateMilestoneData}
// //             bars={DELAY_BAR_DEFS}
// //             minRows={milestoneRowCount}
// //           />
// //         </Col>
// //       </Row>

// //       {/* KPI 9 - Pipeline Stage Analysis */}
// //       <Row gutter={[20, 20]} className="section-block" align="stretch">
// //         <Col xs={24} lg={8}>
// //           <HorizontalStackedBarCard
// //             title="Govt. Land — Pipeline Stage Analysis"
// //             data={govtPipelineData}
// //             bars={PIPELINE_BAR_DEFS}
// //             minRows={pipelineRowCount}
// //           />
// //         </Col>
// //         <Col xs={24} lg={8}>
// //           <HorizontalStackedBarCard
// //             title="MIDC Land — Pipeline Stage Analysis"
// //             data={midcPipelineData}
// //             bars={PIPELINE_BAR_DEFS}
// //             minRows={pipelineRowCount}
// //           />
// //         </Col>
// //         <Col xs={24} lg={8}>
// //           <HorizontalStackedBarCard
// //             title="Private Land — Pipeline Stage Analysis"
// //             data={privatePipelineData}
// //             bars={PIPELINE_BAR_DEFS}
// //             minRows={pipelineRowCount}
// //           />
// //         </Col>
// //       </Row>

// //       {/* Annual Area Acquired - KPI 6 (Horizontal Bar) */}
// //       <Row gutter={[20, 20]} className="section-block">
// //         <Col xs={24}>
// //           <Card className="chart-card" title="Annual Area Acquired (Hectares)">
// //             <ResponsiveContainer width="100%" height={Math.max(annualAreaData.length * 60 + 40, 180)}>
// //               <BarChart
// //                 data={annualAreaData}
// //                 layout="vertical"
// //                 margin={{ top: 4, right: 24, left: 4, bottom: 4 }}
// //                 barSize={16}
// //               >
// //                 <CartesianGrid strokeDasharray="3 3" horizontal={false} />
// //                 <XAxis type="number" />
// //                 <YAxis type="category" dataKey="year" width={70} />
// //                 <RechartsTooltip />
// //                 <Bar dataKey="Govt Land" stackId="a" fill={C.blue} />
// //                 <Bar dataKey="MIDC Land" stackId="a" fill={C.green} />
// //                 <Bar dataKey="Private Land" stackId="a" fill={C.orange} />
// //               </BarChart>
// //             </ResponsiveContainer>
// //             <ChartLegend items={ANNUAL_AREA_BAR_DEFS} />
// //           </Card>
// //         </Col>
// //       </Row>
// //     </div>
// //   );
// // };

// // export default Dashboard;

// import React, { useMemo, useState } from "react";
// import {
//   Card,
//   Row,
//   Col,
//   Typography,
//   Tag,
//   Button,
//   Select,
//   Table,
//   Modal,
//   Space,
//   Tooltip,
// } from "antd";
// import {
//   ThunderboltOutlined,
//   EnvironmentOutlined,
//   CloseCircleOutlined,
//   ReloadOutlined,
//   GlobalOutlined,
//   HomeOutlined,
//   ExclamationCircleOutlined,
//   // All stage icons
//   FileTextOutlined,
//   SafetyCertificateOutlined,
//   DollarOutlined,
//   TeamOutlined,
//   CheckCircleOutlined,
//   ContactsOutlined,
//   KeyOutlined,
//   SearchOutlined,
//   DesktopOutlined,
//   BankOutlined,
//   SolutionOutlined,
//   AuditOutlined,
//   FileProtectOutlined,
//   DownloadOutlined,
// } from "@ant-design/icons";

// import {
//   PieChart,
//   Pie,
//   Cell,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip as RechartsTooltip,
//   ResponsiveContainer,
// } from "recharts";

// import useDashboardMetrics from "../../hooks/dashboard/useDashboardMetrics";
// import useDashboardExport from "../../hooks/dashboard/useDashboardExport";
// import useOrgHierarchy from "../../hooks/projects/useOrgHierarchy";
// import useMilestoneDelays from "../../hooks/dashboard/useMilestoneDelays";
// import "./Dashboard.css";

// const { Text } = Typography;

// // Palette
// const C = {
//   green: "#1a9e5c",
//   greenSoft: "#e8f6ee",
//   blue: "#2e6fdb",
//   blueSoft: "#eaf1fd",
//   orange: "#e07b1a",
//   orangeSoft: "#fdf1e2",
//   red: "#d0392b",
//   redSoft: "#fbe9e7",
//   gray: "#9aa2ac",
//   graySoft: "#eef0f2",
// };

// const STAGE_ICONS = [
//   EnvironmentOutlined,
//   FileTextOutlined,
//   SafetyCertificateOutlined,
//   DollarOutlined,
//   TeamOutlined,
//   CheckCircleOutlined,
//   ContactsOutlined,
//   KeyOutlined,
//   SearchOutlined,
//   DesktopOutlined,
//   BankOutlined,
//   SolutionOutlined,
//   AuditOutlined,
//   FileProtectOutlined,
//   HomeOutlined,
// ];

// const fmtPct = (n) => `${(n ?? 0).toFixed(1)}%`;

// const annotateStages = (stages = [], delaySummary = {}) => {
//   const lastReachedIdx = stages.reduce((last, s, i) => (s.count > 0 ? i : last), -1);

//   return stages.map((s, idx) => {
//     let status = "not-started";
//     if (s.count > 0) {
//       status = s.percentage === 100 ? "completed" : "in-progress";
//     }
//     if (idx === lastReachedIdx && delaySummary) {
//       if (delaySummary.critical_red_total?.count > 0) status = "critical";
//       else if (delaySummary.delayed_orange_total?.count > 0) status = "at-risk";
//     }
//     return { ...s, status };
//   });
// };

// const STATUS_STYLE = {
//   completed: { bg: C.greenSoft, fg: C.green, label: "Completed" },
//   "in-progress": { bg: C.blueSoft, fg: C.blue, label: "In Progress" },
//   "at-risk": { bg: C.orangeSoft, fg: C.orange, label: "Delayed" },
//   critical: { bg: C.redSoft, fg: C.red, label: "Critical" },
//   "not-started": { bg: C.graySoft, fg: C.gray, label: "Yet to Start" },
// };

// const MiniDivider = () => <div className="mini-divider" />;

// const StatCircleCard = ({ icon, label, value, note, accent }) => (
//   <Card className="stat-card" bordered>
//     <div className="stat-card-row">
//       <div className="stat-icon-circle" style={{ background: `${accent}1a`, color: accent }}>
//         {icon}
//       </div>
//       <div className="stat-card-body">
//         <Text className="stat-label">{label}</Text>
//         <div className="stat-value-row">
//           <span className="stat-value">{value}</span>
//         </div>
//         {note && <Text className="stat-note">{note}</Text>}
//       </div>
//     </div>
//   </Card>
// );

// const PieLegendCard = ({ title, data, total, extra }) => (
//   <Card className="chart-card pie-card" title={<span className="card-title">{title}</span>} extra={extra}>
//     <div className="pie-card-flex">
//       <ResponsiveContainer width="55%" height={230}>
//         <PieChart>
//           <Pie data={data} dataKey="value" nameKey="name" innerRadius={55} outerRadius={95} paddingAngle={2}>
//             {data.map((entry, i) => (
//               <Cell key={i} fill={entry.color} />
//             ))}
//           </Pie>
//           <RechartsTooltip />
//         </PieChart>
//       </ResponsiveContainer>
//       <div className="pie-legend-list">
//         {data.map((d, i) => (
//           <div className="pie-legend-item" key={i}>
//             <span className="legend-dot" style={{ background: d.color }} />
//             <span className="pie-legend-name">{d.name}</span>
//             <span className="pie-legend-value">
//               {d.displayValue ?? d.value} ({fmtPct(d.percentage)})
//             </span>
//           </div>
//         ))}
//         <MiniDivider />
//         <div className="pie-legend-total">
//           <span>Total</span>
//           <span className="pie-legend-total-value">{total}</span>
//         </div>
//       </div>
//     </div>
//   </Card>
// );

// const StageTracker = ({ title, stages }) => (
//   <Card className="chart-card tracker-card" title={<span className="card-title">{title}</span>}>
//     <div className="stage-chevron-row">
//       {stages.map((s, i) => {
//         const Icon = STAGE_ICONS[i % STAGE_ICONS.length];
//         const style = STATUS_STYLE[s.status];
//         return (
//           <div className="stage-chip" key={i} style={{ background: style.bg }}>
//             <div className="stage-chip-icon" style={{ color: style.fg }}>
//               <Icon />
//             </div>
//             <div className="stage-chip-label">
//               {s.stage_num}. {s.stage_name}
//             </div>
//             <div className="stage-chip-value" style={{ color: style.fg }}>
//               {s.count} ({fmtPct(s.percentage)})
//             </div>
//           </div>
//         );
//       })}
//     </div>
//     <div className="tracker-legend">
//       {Object.keys(STATUS_STYLE).map((k) => (
//         <span key={k} className="tracker-legend-item">
//           <span
//             className="legend-dot"
//             style={{ background: STATUS_STYLE[k].bg, border: `1px solid ${STATUS_STYLE[k].fg}` }}
//           />
//           {STATUS_STYLE[k].label}
//         </span>
//       ))}
//     </div>
//   </Card>
// );

// /** Legend row matching the same visual style as StageTracker's tracker-legend */
// const ChartLegend = ({ items }) => (
//   <div className="tracker-legend chart-legend">
//     {items.map((it) => (
//       <span key={it.name} className="tracker-legend-item">
//         <span className="legend-dot" style={{ background: it.color, border: `1px solid ${it.color}` }} />
//         {it.name}
//       </span>
//     ))}
//   </div>
// );

// /**
//  * Generic horizontal stacked bar chart card.
//  * `data` = [{ label: 'Milestone / Stage name', <barKey>: number, ... }]
//  * `bars` = [{ dataKey, name, color }]
//  * `minRows` lets sibling cards in the same row share one common chart height.
//  */
// const HorizontalStackedBarCard = ({ title, data, bars, barSize = 14, minRows }) => {
//   const rowCount = Math.max(data.length, minRows || 0);
//   const height = Math.max(rowCount * 40 + 40, 200);
//   return (
//     <Card className="chart-card stacked-hbar-card" title={<span className="card-title">{title}</span>}>
//       <ResponsiveContainer width="100%" height={height}>
//         <BarChart
//           data={data}
//           layout="vertical"
//           margin={{ top: 4, right: 16, left: 4, bottom: 4 }}
//           barSize={barSize}
//           barGap={2}
//         >
//           <CartesianGrid strokeDasharray="3 3" horizontal={false} />
//           <XAxis
//             type="number"
//             allowDecimals={false}
//             label={{
//               value: "Number of Projects",
//               position: "insideBottom",
//               offset: -2,
//               style: {
//                 fontSize: 12,
//                 fontWeight: 600,
//                 fill: "#374151",
//               },
//             }}
//           />

//           <YAxis
//             type="category"
//             dataKey="label"
//             width={150}
//             tick={{
//               fontSize: 11,
//               fill: "#374151",
//             }}
//             label={{
//               value: "Milestone",
//               angle: -90,
//               position: "insideLeft",
//               style: {
//                 fontSize: 12,
//                 fontWeight: 600,
//                 fill: "#374151",
//               },
//             }}
//           />
//           <RechartsTooltip />
//           {bars.map((b) => (
//             <Bar key={b.dataKey} dataKey={b.dataKey} name={b.name} stackId="a" fill={b.color} radius={[0, 0, 0, 0]} />
//           ))}
//         </BarChart>
//       </ResponsiveContainer>
//       <ChartLegend items={bars.map((b) => ({ name: b.name, color: b.color }))} />
//     </Card>
//   );
// };

// const typeLabels = { govt_land: "Govt. Land", midc_land: "MIDC Land", private_land: "Private Land", others: "Others" };
// const typeColors = { govt_land: C.blue, midc_land: C.green, private_land: C.orange, others: C.gray };

// const DELAY_BAR_DEFS = [
//   { dataKey: "on_time", name: "On Time", color: C.green },
//   { dataKey: "delayed_orange", name: "Delayed", color: C.orange },
//   { dataKey: "critical_red", name: "Critical", color: C.red },
// ];

// const PIPELINE_BAR_DEFS = [
//   { dataKey: "completed", name: "Completed", color: C.green },
//   { dataKey: "active_on_time", name: "Active (On Time)", color: C.blue },
//   { dataKey: "delayed_orange", name: "Delayed", color: C.orange },
//   { dataKey: "critical_red", name: "Critical", color: C.red },
//   { dataKey: "not_started", name: "Yet to Start", color: C.gray },
// ];

// const ANNUAL_AREA_BAR_DEFS = [
//   { dataKey: "Govt Land", name: "Govt Land", color: C.blue },
//   { dataKey: "MIDC Land", name: "MIDC Land", color: C.green },
//   { dataKey: "Private Land", name: "Private Land", color: C.orange },
// ];

// const mapMilestones = (milestones = []) =>
//   milestones.map((m) => ({
//     label: m.milestone_step,
//     on_time: m.on_time?.count || 0,
//     delayed_orange: m.delayed_orange?.count || 0,
//     critical_red: m.critical_red?.count || 0,
//   }));

// const mapPipelineStages = (stages = []) =>
//   stages.map((s) => ({
//     label: `${s.stage_num}. ${s.stage_name}`,
//     completed: s.completed?.count || 0,
//     active_on_time: s.active_on_time?.count || 0,
//     delayed_orange: s.delayed_orange?.count || 0,
//     critical_red: s.critical_red?.count || 0,
//     not_started: s.not_started?.count || 0,
//   }));

// const ALL_ZONES_VALUE = "__all__";

// const delayColumns = [
//   {
//     title: "Project",
//     dataIndex: "project_name",
//     key: "project_name",
//     ellipsis: true,
//     render: (text, record) => (
//       <Tooltip title={`ID: ${record.project_id}`}>
//         <span>{text}</span>
//       </Tooltip>
//     ),
//   },
//   {
//     title: "Land Type",
//     dataIndex: "land_type",
//     key: "land_type",
//     width: 100,
//     render: (t) => {
//       const map = { GOVT: "Govt", MIDC: "MIDC", PRIVATE: "Private" };
//       return <Tag>{map[t] || t}</Tag>;
//     },
//   },
//   {
//     title: "Delayed Step",
//     dataIndex: "delayed_step",
//     key: "delayed_step",
//     ellipsis: true,
//   },
//   {
//     title: "Next Step",
//     dataIndex: "next_step",
//     key: "next_step",
//     ellipsis: true,
//   },
//   {
//     title: "Delay (Days)",
//     dataIndex: "delay_days",
//     key: "delay_days",
//     width: 110,
//     sorter: (a, b) => a.delay_days - b.delay_days,
//     defaultSortOrder: "descend",
//     render: (d) => (
//       <span style={{ fontWeight: 600, color: d > 30 ? C.red : C.orange }}>{d}</span>
//     ),
//   },
//   {
//     title: "Severity",
//     dataIndex: "severity",
//     key: "severity",
//     width: 110,
//     render: (s) => (
//       <Tag color={s === "CRITICAL" ? "error" : "warning"}>
//         {s === "CRITICAL" ? "Critical" : "Delayed"}
//       </Tag>
//     ),
//   },
// ];

// const Dashboard = () => {
//   const { zonesList, loading: zonesLoading } = useOrgHierarchy();
//   const [selectedZone, setSelectedZone] = useState(ALL_ZONES_VALUE);
//   const { downloadReport, exporting } = useDashboardExport();
//   const zoneNameParam = selectedZone === ALL_ZONES_VALUE ? undefined : selectedZone;
//   const { metrics, loading, error, fetchMetrics } = useDashboardMetrics(zoneNameParam);

//   // Milestone delay details
//   const {
//     data: milestoneDelays,
//     loading: delaysLoading,
//     refetch: refetchDelays,
//   } = useMilestoneDelays(zoneNameParam);

//   const [delayModalOpen, setDelayModalOpen] = useState(false);
//   const [delayModalFilter, setDelayModalFilter] = useState(null); // "CRITICAL" | "DELAYED" | null

//   const openDelayDetails = (severity = null) => {
//     setDelayModalFilter(severity);
//     setDelayModalOpen(true);
//   };

//   const handleRefresh = () => {
//     fetchMetrics();
//     refetchDelays();
//   };

//   const zoneOptions = useMemo(
//     () => [
//       { value: ALL_ZONES_VALUE, label: "All Zones" },
//       ...zonesList.map((z) => ({ value: z.name, label: z.name })),
//     ],
//     [zonesList]
//   );

//   const now = useMemo(() => new Date(), []);

//   const {
//     kpi_1_portfolio_summary: summary,
//     kpi_2_in_possession_bifurcation: possessionByType,
//     kpi_3_not_in_possession_identification_status: idStatus,
//     kpi_4_most_feasible_land_trifurcation: feasibleByType,
//     kpi_5_progress_reports,
//     kpi_6_annual_area_acquired_hectares: annualArea,
//     kpi_7_horizontal_stacked_delays: stackedDelays,
//     kpi_8_overall_portfolio_delay: overallDelay,
//     kpi_9_pipeline_stage_analysis: pipelineAnalysis,
//   } = metrics || {};

//   // ---- KPI 2 donut: In-Possession bifurcation by land type ----
//   const possessionTypeDonutData = useMemo(
//     () =>
//       Object.entries(possessionByType || {}).map(([k, v]) => ({
//         name: typeLabels[k] || k,
//         value: v.count || 0,
//         percentage: v.percentage || 0,
//         color: typeColors[k] || C.gray,
//       })),
//     [possessionByType]
//   );
//   const possessionTypeTotal = Object.values(possessionByType || {}).reduce((a, v) => a + (v.count || 0), 0);

//   // ---- KPI 3 donut: Not-in-possession identification status ----
//   const idStatusLabels = {
//     not_yet_identified: "Not Yet Identified",
//     multiple_lands_identified: "Multiple Lands Identified",
//     most_feasible_land_identified: "Most Feasible Land Identified",
//   };
//   const idStatusColors = {
//     not_yet_identified: C.orange,
//     multiple_lands_identified: C.blue,
//     most_feasible_land_identified: C.green,
//   };
//   const idStatusDonutData = useMemo(
//     () =>
//       Object.entries(idStatus || {}).map(([k, v]) => ({
//         name: idStatusLabels[k] || k,
//         value: v.count || 0,
//         percentage: v.percentage || 0,
//         color: idStatusColors[k] || C.gray,
//       })),
//     [idStatus]
//   );
//   const idStatusTotal = Object.values(idStatus || {}).reduce((a, v) => a + (v.count || 0), 0);

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="loading-spinner" />
//         <p>Loading Dashboard Metrics...</p>
//       </div>
//     );
//   }

//   if (error || !metrics) {
//     return (
//       <Card className="dashboard-error-card">
//         <div className="error-content">
//           <CloseCircleOutlined style={{ fontSize: 48, color: "#ef4444" }} />
//           <Text type="danger">Failed to load dashboard data.</Text>
//           <Button onClick={handleRefresh} type="primary" icon={<ReloadOutlined />}>
//             Retry
//           </Button>
//         </div>
//       </Card>
//     );
//   }

//   const totalProjects = summary?.total_projects?.count || 0;

//   const govtStages = annotateStages(kpi_5_progress_reports?.kpi_5_1_govt_land_stages || [], overallDelay?.govt_land);
//   const midcStages = annotateStages(kpi_5_progress_reports?.kpi_5_2_midc_land_stages || [], overallDelay?.midc_land);
//   const privateStages = annotateStages(kpi_5_progress_reports?.kpi_5_3_private_land_stages || [], overallDelay?.private_land);

//   const feasibleTypeRows = Object.entries(feasibleByType || {}).map(([k, v]) => ({
//     key: k,
//     label: typeLabels[k] || k,
//     color: typeColors[k] || C.gray,
//     ...v,
//   }));

//   const delayRows = Object.entries(overallDelay || {}).map(([k, v]) => ({
//     key: k,
//     label: typeLabels[k] || k,
//     ...v,
//   }));

//   // ---- KPI 7: horizontal stacked milestone delay charts ----
//   const govtMilestoneData = mapMilestones(stackedDelays?.kpi_7_1_govt_land_milestones);
//   const midcMilestoneData = mapMilestones(stackedDelays?.kpi_7_2_midc_land_milestones);
//   const privateMilestoneData = mapMilestones(stackedDelays?.kpi_7_3_private_land_milestones);
//   const milestoneRowCount = Math.max(
//     govtMilestoneData.length,
//     midcMilestoneData.length,
//     privateMilestoneData.length
//   );

//   // ---- KPI 9: pipeline stage analysis charts ----
//   const govtPipelineData = mapPipelineStages(pipelineAnalysis?.govt_land_stages);
//   const midcPipelineData = mapPipelineStages(pipelineAnalysis?.midc_land_stages);
//   const privatePipelineData = mapPipelineStages(pipelineAnalysis?.private_land_stages);
//   const pipelineRowCount = Math.max(
//     govtPipelineData.length,
//     midcPipelineData.length,
//     privatePipelineData.length
//   );

//   const annualAreaData = Object.entries(annualArea || {}).map(([year, y]) => ({
//     year,
//     "Govt Land": y?.govt_land?.area_hectares || 0,
//     "MIDC Land": y?.midc_land?.area_hectares || 0,
//     "Private Land": y?.private_land?.area_hectares || 0,
//   }));

//   const criticalCount = milestoneDelays.filter((d) => d.severity === "CRITICAL").length;
//   const delayedCount = milestoneDelays.filter((d) => d.severity === "DELAYED").length;

//   return (
//     <div className="dashboard-container">
//       {/* Top Bar */}
//       <div className="dashboard-topbar">
//         <div className="brand-block">
//           <div className="brand-logo">
//             <ThunderboltOutlined />
//           </div>
//           <div>
//             <Text className="brand-name">Land Acquisition Monitoring Portal</Text>
//             <div className="brand-sub">Executive Portfolio Review Dashboard</div>
//           </div>
//         </div>

//         <div className="topbar-right">
//           <Select
//             className="zone-select"
//             suffixIcon={<GlobalOutlined />}
//             value={selectedZone}
//             onChange={setSelectedZone}
//             options={zoneOptions}
//             loading={zonesLoading}
//             popupMatchSelectWidth={false}
//           />

//           <Button className="refresh-btn" type="primary" icon={<ReloadOutlined />} onClick={handleRefresh}>
//             Refresh
//           </Button>
//           <Button
//             className="refresh-btn"
//             type="default"
//             icon={<DownloadOutlined />}
//             loading={exporting}
//             onClick={downloadReport}
//             style={{ marginLeft: 8, color: "#fff" }}
//           >
//             Report
//           </Button>
//         </div>
//       </div>

//       {/* KPI 1 - Summary Cards (4 cards) */}
//       <Row gutter={[20, 20]} className="section-block" align="stretch">
//         <Col xs={24} sm={12} md={6}>
//           <StatCircleCard
//             icon={<EnvironmentOutlined />}
//             label="Total Projects"
//             value={totalProjects}
//             accent={C.blue}
//           />
//         </Col>
//         <Col xs={24} sm={12} md={6}>
//           <StatCircleCard
//             icon={<HomeOutlined />}
//             label="Projects in Possession"
//             value={summary?.in_possession?.count || 0}
//             accent={C.green}
//           />
//         </Col>
//         <Col xs={24} sm={12} md={6}>
//           <StatCircleCard
//             icon={<CloseCircleOutlined />}
//             label="Projects Not in Possession"
//             value={summary?.not_in_possession?.count || 0}
//             accent={C.orange}
//           />
//         </Col>
//         <Col xs={24} sm={12} md={6}>
//           <StatCircleCard
//             icon={<ExclamationCircleOutlined />}
//             label="Overall Delayed Projects"
//             value={summary?.overall_delayed_projects?.count || 0}
//             accent={C.red}
//           />
//         </Col>
//       </Row>

//       {/* Donut Charts - KPI 2 & KPI 3 */}
//       <Row gutter={[20, 20]} className="section-block" align="stretch">
//         <Col xs={24} lg={12}>
//           <PieLegendCard
//             title="In-Possession Land — By Type"
//             data={possessionTypeDonutData}
//             total={possessionTypeTotal}
//           />
//         </Col>
//         <Col xs={24} lg={12}>
//           <PieLegendCard
//             title="Not-in-Possession — Identification Status"
//             data={idStatusDonutData}
//             total={idStatusTotal}
//           />
//         </Col>
//       </Row>

//       {/* Most Feasible Land (KPI 4) + Overall Portfolio Delay (KPI 8) - single row */}
//       <Row gutter={[20, 20]} className="section-block" align="stretch">
//         <Col xs={24} lg={12}>
//           <Card className="chart-card" title="Most Feasible Land Identified — By Type">
//             <div className="feasible-list">
//               {feasibleTypeRows.map((r) => (
//                 <div className="mini-feasible-row" key={r.key}>
//                   <span className="legend-dot" style={{ background: r.color }} />
//                   <span className="mini-feasible-label">{r.label}</span>
//                   <span className="mini-feasible-value" style={{ color: r.color }}>
//                     {r.count} ({fmtPct(r.percentage)})
//                   </span>
//                 </div>
//               ))}
//             </div>
//           </Card>
//         </Col>
//         <Col xs={24} lg={12}>
//           <Card className="chart-card" title="Overall Portfolio Delay by Land Type">
//             <div className="delay-table delay-table-compact">
//               <div className="delay-table-header">
//                 <span>Land Type</span>
//                 <span>Avg. Delay (Days)</span>
//                 <span>On Time</span>
//                 <span>Delayed</span>
//                 <span>Critical</span>
//               </div>
//               {delayRows.map((r) => (
//                 <div className="delay-table-row" key={r.key}>
//                   <span className="project-name">{r.label}</span>
//                   <span className={r.avg_overall_delay_days > 0 ? "delay-days-bad" : "delay-days-good"}>
//                     {r.avg_overall_delay_days}
//                   </span>
//                   <Tag color="success">{r.on_time_total?.count || 0}</Tag>
//                   <Tag color="warning">{r.delayed_orange_total?.count || 0}</Tag>
//                   <Tag color="error">{r.critical_red_total?.count || 0}</Tag>
//                 </div>
//               ))}
//             </div>
//           </Card>
//         </Col>
//       </Row>

//       {/* Stage Trackers - KPI 5 */}
//       <Row gutter={[20, 20]} className="section-block">
//         <Col xs={24}>
//           <StageTracker title="Government Land Acquisition Progress (8-Stage)" stages={govtStages} />
//         </Col>
//       </Row>

//       <Row gutter={[20, 20]} className="section-block" align="stretch">
//         <Col xs={24} xl={12}>
//           <StageTracker title="Private Land Acquisition Progress (6-Stage)" stages={privateStages} />
//         </Col>
//         <Col xs={24} xl={12}>
//           <StageTracker title="MIDC Land Acquisition Progress (5-Stage)" stages={midcStages} />
//         </Col>
//       </Row>

//       {/* KPI 7 header + action buttons */}
//       <Row gutter={[20, 20]} className="section-block" style={{ marginBottom: 0 }}>
//         <Col span={24}>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               marginBottom: 12,
//               flexWrap: "wrap",
//               gap: 8,
//             }}
//           >
//             <Text strong style={{ fontSize: 16 }}>
//               Milestone Delay Status
//             </Text>
//             <Space wrap>
//               <Button
//                 size="small"
//                 danger
//                 onClick={() => openDelayDetails("CRITICAL")}
//                 loading={delaysLoading}
//               >
//                 View Critical ({criticalCount})
//               </Button>
//               <Button
//                 size="small"
//                 style={{ color: C.orange, borderColor: C.orange }}
//                 onClick={() => openDelayDetails("DELAYED")}
//                 loading={delaysLoading}
//               >
//                 View Delayed ({delayedCount})
//               </Button>
//               <Button size="small" onClick={() => openDelayDetails(null)} loading={delaysLoading}>
//                 View All Details
//               </Button>
//             </Space>
//           </div>
//         </Col>
//       </Row>

//       {/* KPI 7 - Horizontal Stacked Milestone Delay Charts */}
//       <Row gutter={[20, 20]} className="section-block" align="stretch">
//         <Col xs={24} lg={8}>
//           <HorizontalStackedBarCard
//             title="Govt. Land — Milestone Delay Status"
//             data={govtMilestoneData}
//             bars={DELAY_BAR_DEFS}
//             minRows={milestoneRowCount}
//           />
//         </Col>
//         <Col xs={24} lg={8}>
//           <HorizontalStackedBarCard
//             title="MIDC Land — Milestone Delay Status"
//             data={midcMilestoneData}
//             bars={DELAY_BAR_DEFS}
//             minRows={milestoneRowCount}
//           />
//         </Col>
//         <Col xs={24} lg={8}>
//           <HorizontalStackedBarCard
//             title="Private Land — Milestone Delay Status"
//             data={privateMilestoneData}
//             bars={DELAY_BAR_DEFS}
//             minRows={milestoneRowCount}
//           />
//         </Col>
//       </Row>

//       {/* KPI 9 - Pipeline Stage Analysis */}
//       <Row gutter={[20, 20]} className="section-block" align="stretch">
//         <Col xs={24} lg={8}>
//           <HorizontalStackedBarCard
//             title="Govt. Land — Pipeline Stage Analysis"
//             data={govtPipelineData}
//             bars={PIPELINE_BAR_DEFS}
//             minRows={pipelineRowCount}
//           />
//         </Col>
//         <Col xs={24} lg={8}>
//           <HorizontalStackedBarCard
//             title="MIDC Land — Pipeline Stage Analysis"
//             data={midcPipelineData}
//             bars={PIPELINE_BAR_DEFS}
//             minRows={pipelineRowCount}
//           />
//         </Col>
//         <Col xs={24} lg={8}>
//           <HorizontalStackedBarCard
//             title="Private Land — Pipeline Stage Analysis"
//             data={privatePipelineData}
//             bars={PIPELINE_BAR_DEFS}
//             minRows={pipelineRowCount}
//           />
//         </Col>
//       </Row>

//       {/* Annual Area Acquired - KPI 6 (Horizontal Bar) */}
//       <Row gutter={[20, 20]} className="section-block">
//         <Col xs={24}>
//           <Card className="chart-card" title="Annual Area Acquired (Hectares)">
//             <ResponsiveContainer width="100%" height={Math.max(annualAreaData.length * 60 + 40, 180)}>
//               <BarChart
//                 data={annualAreaData}
//                 layout="vertical"
//                 margin={{ top: 4, right: 24, left: 4, bottom: 4 }}
//                 barSize={16}
//               >
//                 <CartesianGrid strokeDasharray="3 3" horizontal={false} />
//                 <XAxis type="number" />
//                 <YAxis type="category" dataKey="year" width={70} />
//                 <RechartsTooltip />
//                 <Bar dataKey="Govt Land" stackId="a" fill={C.blue} />
//                 <Bar dataKey="MIDC Land" stackId="a" fill={C.green} />
//                 <Bar dataKey="Private Land" stackId="a" fill={C.orange} />
//               </BarChart>
//             </ResponsiveContainer>
//             <ChartLegend items={ANNUAL_AREA_BAR_DEFS} />
//           </Card>
//         </Col>
//       </Row>

//       {/* Delay Details Modal */}
//       <Modal
//         title={
//           delayModalFilter === "CRITICAL"
//             ? "Critical Milestone Delays"
//             : delayModalFilter === "DELAYED"
//             ? "Delayed Milestone Details"
//             : "All Delayed & Critical Milestones"
//         }
//         open={delayModalOpen}
//         onCancel={() => setDelayModalOpen(false)}
//         footer={null}
//         width={1100}
//         destroyOnClose
//       >
//         <Table
//           rowKey={(r) => `${r.project_id}-${r.delayed_step}`}
//           columns={delayColumns}
//           dataSource={
//             delayModalFilter
//               ? milestoneDelays.filter((d) => d.severity === delayModalFilter)
//               : milestoneDelays
//           }
//           loading={delaysLoading}
//           size="small"
//           pagination={{ pageSize: 10, showSizeChanger: true }}
//           scroll={{ x: 900 }}
//         />
//       </Modal>
//     </div>
//   );
// };

// export default Dashboard;


import React, { useMemo, useState } from "react";
import {
  Card,
  Row,
  Col,
  Typography,
  Tag,
  Button,
  Select,
  Table,
  Tooltip,
  Space,
} from "antd";
import {
  ThunderboltOutlined,
  EnvironmentOutlined,
  CloseCircleOutlined,
  ReloadOutlined,
  GlobalOutlined,
  HomeOutlined,
  ExclamationCircleOutlined,
  FileTextOutlined,
  SafetyCertificateOutlined,
  DollarOutlined,
  TeamOutlined,
  CheckCircleOutlined,
  ContactsOutlined,
  KeyOutlined,
  SearchOutlined,
  DesktopOutlined,
  BankOutlined,
  SolutionOutlined,
  AuditOutlined,
  FileProtectOutlined,
  DownloadOutlined,
} from "@ant-design/icons";

import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
} from "recharts";

import useDashboardMetrics from "../../hooks/dashboard/useDashboardMetrics";
import useDashboardExport from "../../hooks/dashboard/useDashboardExport";
import useOrgHierarchy from "../../hooks/projects/useOrgHierarchy";
import useMilestoneDelays from "../../hooks/dashboard/useMilestoneDelays";
import "./Dashboard.css";

const { Text } = Typography;

// Palette
const C = {
  green: "#1a9e5c",
  greenSoft: "#e8f6ee",
  blue: "#2e6fdb",
  blueSoft: "#eaf1fd",
  orange: "#e07b1a",
  orangeSoft: "#fdf1e2",
  red: "#d0392b",
  redSoft: "#fbe9e7",
  gray: "#9aa2ac",
  graySoft: "#eef0f2",
};

const STAGE_ICONS = [
  EnvironmentOutlined,
  FileTextOutlined,
  SafetyCertificateOutlined,
  DollarOutlined,
  TeamOutlined,
  CheckCircleOutlined,
  ContactsOutlined,
  KeyOutlined,
  SearchOutlined,
  DesktopOutlined,
  BankOutlined,
  SolutionOutlined,
  AuditOutlined,
  FileProtectOutlined,
  HomeOutlined,
];

const fmtPct = (n) => `${(n ?? 0).toFixed(1)}%`;

const annotateStages = (stages = [], delaySummary = {}) => {
  const lastReachedIdx = stages.reduce((last, s, i) => (s.count > 0 ? i : last), -1);

  return stages.map((s, idx) => {
    let status = "not-started";
    if (s.count > 0) {
      status = s.percentage === 100 ? "completed" : "in-progress";
    }
    if (idx === lastReachedIdx && delaySummary) {
      if (delaySummary.critical_red_total?.count > 0) status = "critical";
      else if (delaySummary.delayed_orange_total?.count > 0) status = "at-risk";
    }
    return { ...s, status };
  });
};

const STATUS_STYLE = {
  completed: { bg: C.greenSoft, fg: C.green, label: "Completed" },
  "in-progress": { bg: C.blueSoft, fg: C.blue, label: "In Progress" },
  "at-risk": { bg: C.orangeSoft, fg: C.orange, label: "Delayed" },
  critical: { bg: C.redSoft, fg: C.red, label: "Critical" },
  "not-started": { bg: C.graySoft, fg: C.gray, label: "Yet to Start" },
};

const MiniDivider = () => <div className="mini-divider" />;

const StatCircleCard = ({ icon, label, value, note, accent }) => (
  <Card className="stat-card" bordered>
    <div className="stat-card-row">
      <div className="stat-icon-circle" style={{ background: `${accent}1a`, color: accent }}>
        {icon}
      </div>
      <div className="stat-card-body">
        <Text className="stat-label">{label}</Text>
        <div className="stat-value-row">
          <span className="stat-value">{value}</span>
        </div>
        {note && <Text className="stat-note">{note}</Text>}
      </div>
    </div>
  </Card>
);

const PieLegendCard = ({ title, data, total, extra }) => (
  <Card className="chart-card pie-card" title={<span className="card-title">{title}</span>} extra={extra}>
    <div className="pie-card-flex">
      <ResponsiveContainer width="55%" height={230}>
        <PieChart>
          <Pie data={data} dataKey="value" nameKey="name" innerRadius={55} outerRadius={95} paddingAngle={2}>
            {data.map((entry, i) => (
              <Cell key={i} fill={entry.color} />
            ))}
          </Pie>
          <RechartsTooltip />
        </PieChart>
      </ResponsiveContainer>
      <div className="pie-legend-list">
        {data.map((d, i) => (
          <div className="pie-legend-item" key={i}>
            <span className="legend-dot" style={{ background: d.color }} />
            <span className="pie-legend-name">{d.name}</span>
            <span className="pie-legend-value">
              {d.displayValue ?? d.value} ({fmtPct(d.percentage)})
            </span>
          </div>
        ))}
        <MiniDivider />
        <div className="pie-legend-total">
          <span>Total</span>
          <span className="pie-legend-total-value">{total}</span>
        </div>
      </div>
    </div>
  </Card>
);

const StageTracker = ({ title, stages }) => (
  <Card className="chart-card tracker-card" title={<span className="card-title">{title}</span>}>
    <div className="stage-chevron-row">
      {stages.map((s, i) => {
        const Icon = STAGE_ICONS[i % STAGE_ICONS.length];
        const style = STATUS_STYLE[s.status];
        return (
          <div className="stage-chip" key={i} style={{ background: style.bg }}>
            <div className="stage-chip-icon" style={{ color: style.fg }}>
              <Icon />
            </div>
            <div className="stage-chip-label">
              {s.stage_num}. {s.stage_name}
            </div>
            <div className="stage-chip-value" style={{ color: style.fg }}>
              {s.count} ({fmtPct(s.percentage)})
            </div>
          </div>
        );
      })}
    </div>
    <div className="tracker-legend">
      {Object.keys(STATUS_STYLE).map((k) => (
        <span key={k} className="tracker-legend-item">
          <span
            className="legend-dot"
            style={{ background: STATUS_STYLE[k].bg, border: `1px solid ${STATUS_STYLE[k].fg}` }}
          />
          {STATUS_STYLE[k].label}
        </span>
      ))}
    </div>
  </Card>
);

const ChartLegend = ({ items }) => (
  <div className="tracker-legend chart-legend">
    {items.map((it) => (
      <span key={it.name} className="tracker-legend-item">
        <span className="legend-dot" style={{ background: it.color, border: `1px solid ${it.color}` }} />
        {it.name}
      </span>
    ))}
  </div>
);

const HorizontalStackedBarCard = ({ title, data, bars, barSize = 14, minRows }) => {
  const rowCount = Math.max(data.length, minRows || 0);
  const height = Math.max(rowCount * 40 + 40, 200);
  return (
    <Card className="chart-card stacked-hbar-card" title={<span className="card-title">{title}</span>}>
      <ResponsiveContainer width="100%" height={height}>
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 4, right: 16, left: 4, bottom: 4 }}
          barSize={barSize}
          barGap={2}
        >
          <CartesianGrid strokeDasharray="3 3" horizontal={false} />
          <XAxis
            type="number"
            allowDecimals={false}
            label={{
              value: "Number of Projects",
              position: "insideBottom",
              offset: -2,
              style: { fontSize: 12, fontWeight: 600, fill: "#374151" },
            }}
          />
          <YAxis
            type="category"
            dataKey="label"
            width={150}
            tick={{ fontSize: 11, fill: "#374151" }}
            label={{
              value: "Milestone",
              angle: -90,
              position: "insideLeft",
              style: { fontSize: 12, fontWeight: 600, fill: "#374151" },
            }}
          />
          <RechartsTooltip />
          {bars.map((b) => (
            <Bar key={b.dataKey} dataKey={b.dataKey} name={b.name} stackId="a" fill={b.color} radius={[0, 0, 0, 0]} />
          ))}
        </BarChart>
      </ResponsiveContainer>
      <ChartLegend items={bars.map((b) => ({ name: b.name, color: b.color }))} />
    </Card>
  );
};

const typeLabels = {
  govt_land: "Govt. Land",
  midc_land: "MIDC Land",
  private_land: "Private Land",
  others: "Others",
};
const typeColors = {
  govt_land: C.blue,
  midc_land: C.green,
  private_land: C.orange,
  others: C.gray,
};

const DELAY_BAR_DEFS = [
  { dataKey: "on_time", name: "On Time", color: C.green },
  { dataKey: "delayed_orange", name: "Delayed", color: C.orange },
  { dataKey: "critical_red", name: "Critical", color: C.red },
];

const PIPELINE_BAR_DEFS = [
  { dataKey: "completed", name: "Completed", color: C.green },
  { dataKey: "active_on_time", name: "Active (On Time)", color: C.blue },
  { dataKey: "delayed_orange", name: "Delayed", color: C.orange },
  { dataKey: "critical_red", name: "Critical", color: C.red },
  { dataKey: "not_started", name: "Yet to Start", color: C.gray },
];

const mapMilestones = (milestones = []) =>
  milestones.map((m) => ({
    label: m.milestone_step,
    on_time: m.on_time?.count || 0,
    delayed_orange: m.delayed_orange?.count || 0,
    critical_red: m.critical_red?.count || 0,
  }));

const mapPipelineStages = (stages = []) =>
  stages.map((s) => ({
    label: `${s.stage_num}. ${s.stage_name}`,
    completed: s.completed?.count || 0,
    active_on_time: s.active_on_time?.count || 0,
    delayed_orange: s.delayed_orange?.count || 0,
    critical_red: s.critical_red?.count || 0,
    not_started: s.not_started?.count || 0,
  }));

const ALL_ZONES_VALUE = "__all__";

const delayColumns = [
  {
    title: "Project",
    dataIndex: "project_name",
    key: "project_name",
    ellipsis: true,
    render: (text, record) => (
      <Tooltip title={`ID: ${record.project_id}`}>
        <span style={{ fontWeight: 500 }}>{text}</span>
      </Tooltip>
    ),
  },
  {
    title: "Land Type",
    dataIndex: "land_type",
    key: "land_type",
    width: 110,
    render: (t) => {
      const map = { GOVT: "Govt", MIDC: "MIDC", PRIVATE: "Private" };
      const colorMap = { GOVT: "blue", MIDC: "green", PRIVATE: "orange" };
      return <Tag color={colorMap[t] || "default"}>{map[t] || t}</Tag>;
    },
  },
  {
    title: "Delayed Step",
    dataIndex: "delayed_step",
    key: "delayed_step",
    ellipsis: true,
  },
  {
    title: "Next Step",
    dataIndex: "next_step",
    key: "next_step",
    ellipsis: true,
  },
  {
    title: "Delay (Days)",
    dataIndex: "delay_days",
    key: "delay_days",
    width: 120,
    sorter: (a, b) => a.delay_days - b.delay_days,
    defaultSortOrder: "descend",
    render: (d) => (
      <span style={{ fontWeight: 600, color: d > 30 ? C.red : C.orange }}>{d}</span>
    ),
  },
  {
    title: "Severity",
    dataIndex: "severity",
    key: "severity",
    width: 110,
    filters: [
      { text: "Critical", value: "CRITICAL" },
      { text: "Delayed", value: "DELAYED" },
    ],
    onFilter: (value, record) => record.severity === value,
    render: (s) => (
      <Tag color={s === "CRITICAL" ? "error" : "warning"}>
        {s === "CRITICAL" ? "Critical" : "Delayed"}
      </Tag>
    ),
  },
];

const Dashboard = () => {
  const { zonesList, loading: zonesLoading } = useOrgHierarchy();
  const [selectedZone, setSelectedZone] = useState(ALL_ZONES_VALUE);
  const { downloadReport, exporting } = useDashboardExport();
  const zoneNameParam = selectedZone === ALL_ZONES_VALUE ? undefined : selectedZone;

  const { metrics, loading, error, fetchMetrics } = useDashboardMetrics(zoneNameParam);
  const {
    data: milestoneDelays,
    loading: delaysLoading,
    refetch: refetchDelays,
  } = useMilestoneDelays(zoneNameParam);

  const handleRefresh = () => {
    fetchMetrics();
    refetchDelays();
  };

  const zoneOptions = useMemo(
    () => [
      { value: ALL_ZONES_VALUE, label: "All Zones" },
      ...zonesList.map((z) => ({ value: z.name, label: z.name })),
    ],
    [zonesList]
  );

  const {
    kpi_1_portfolio_summary: summary,
    kpi_2_in_possession_bifurcation: possessionByType,
    kpi_3_not_in_possession_identification_status: idStatus,
    kpi_4_most_feasible_land_trifurcation: feasibleByType,
    kpi_5_progress_reports,
    kpi_7_horizontal_stacked_delays: stackedDelays,
    kpi_8_overall_portfolio_delay: overallDelay,
    kpi_9_pipeline_stage_analysis: pipelineAnalysis,
  } = metrics || {};

  // KPI 2
  const possessionTypeDonutData = useMemo(
    () =>
      Object.entries(possessionByType || {}).map(([k, v]) => ({
        name: typeLabels[k] || k,
        value: v.count || 0,
        percentage: v.percentage || 0,
        color: typeColors[k] || C.gray,
      })),
    [possessionByType]
  );
  const possessionTypeTotal = Object.values(possessionByType || {}).reduce(
    (a, v) => a + (v.count || 0),
    0
  );

  // KPI 3
  const idStatusLabels = {
    not_yet_identified: "Not Yet Identified",
    multiple_lands_identified: "Multiple Lands Identified",
    most_feasible_land_identified: "Most Feasible Land Identified",
  };
  const idStatusColors = {
    not_yet_identified: C.orange,
    multiple_lands_identified: C.blue,
    most_feasible_land_identified: C.green,
  };
  const idStatusDonutData = useMemo(
    () =>
      Object.entries(idStatus || {}).map(([k, v]) => ({
        name: idStatusLabels[k] || k,
        value: v.count || 0,
        percentage: v.percentage || 0,
        color: idStatusColors[k] || C.gray,
      })),
    [idStatus]
  );
  const idStatusTotal = Object.values(idStatus || {}).reduce((a, v) => a + (v.count || 0), 0);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner" />
        <p>Loading Dashboard Metrics...</p>
      </div>
    );
  }

  if (error || !metrics) {
    return (
      <Card className="dashboard-error-card">
        <div className="error-content">
          <CloseCircleOutlined style={{ fontSize: 48, color: "#ef4444" }} />
          <Text type="danger">Failed to load dashboard data.</Text>
          <Button onClick={handleRefresh} type="primary" icon={<ReloadOutlined />}>
            Retry
          </Button>
        </div>
      </Card>
    );
  }

  const totalProjects = summary?.total_projects?.count || 0;

  const govtStages = annotateStages(
    kpi_5_progress_reports?.kpi_5_1_govt_land_stages || [],
    overallDelay?.govt_land
  );
  const midcStages = annotateStages(
    kpi_5_progress_reports?.kpi_5_2_midc_land_stages || [],
    overallDelay?.midc_land
  );
  const privateStages = annotateStages(
    kpi_5_progress_reports?.kpi_5_3_private_land_stages || [],
    overallDelay?.private_land
  );

  const feasibleTypeRows = Object.entries(feasibleByType || {}).map(([k, v]) => ({
    key: k,
    label: typeLabels[k] || k,
    color: typeColors[k] || C.gray,
    ...v,
  }));

  const delayRows = Object.entries(overallDelay || {}).map(([k, v]) => ({
    key: k,
    label: typeLabels[k] || k,
    ...v,
  }));

  // KPI 7
  const govtMilestoneData = mapMilestones(stackedDelays?.kpi_7_1_govt_land_milestones);
  const midcMilestoneData = mapMilestones(stackedDelays?.kpi_7_2_midc_land_milestones);
  const privateMilestoneData = mapMilestones(stackedDelays?.kpi_7_3_private_land_milestones);
  const milestoneRowCount = Math.max(
    govtMilestoneData.length,
    midcMilestoneData.length,
    privateMilestoneData.length
  );

  // KPI 9
  const govtPipelineData = mapPipelineStages(pipelineAnalysis?.govt_land_stages);
  const midcPipelineData = mapPipelineStages(pipelineAnalysis?.midc_land_stages);
  const privatePipelineData = mapPipelineStages(pipelineAnalysis?.private_land_stages);
  const pipelineRowCount = Math.max(
    govtPipelineData.length,
    midcPipelineData.length,
    privatePipelineData.length
  );

  const criticalCount = milestoneDelays.filter((d) => d.severity === "CRITICAL").length;
  const delayedCount = milestoneDelays.filter((d) => d.severity === "DELAYED").length;

  return (
    <div className="dashboard-container">
      {/* Top Bar */}
      <div className="dashboard-topbar">
        <div className="brand-block">
          <div className="brand-logo">
            <ThunderboltOutlined />
          </div>
          <div>
            <Text className="brand-name">Land Acquisition Monitoring Portal</Text>
            <div className="brand-sub">Executive Portfolio Review Dashboard</div>
          </div>
        </div>

        <div className="topbar-right">
          <Select
            className="zone-select"
            suffixIcon={<GlobalOutlined />}
            value={selectedZone}
            onChange={setSelectedZone}
            options={zoneOptions}
            loading={zonesLoading}
            popupMatchSelectWidth={false}
          />

          <Button
            className="refresh-btn"
            type="primary"
            icon={<ReloadOutlined />}
            onClick={handleRefresh}
          >
            Refresh
          </Button>
          <Button
            className="refresh-btn"
            type="default"
            icon={<DownloadOutlined />}
            loading={exporting}
            onClick={downloadReport}
            style={{ marginLeft: 8, color: "#fff" }}
          >
            Report
          </Button>
        </div>
      </div>

      {/* KPI 1 - Summary Cards */}
      <Row gutter={[20, 20]} className="section-block" align="stretch">
        <Col xs={24} sm={12} md={6}>
          <StatCircleCard
            icon={<EnvironmentOutlined />}
            label="Total Projects"
            value={totalProjects}
            accent={C.blue}
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <StatCircleCard
            icon={<HomeOutlined />}
            label="Projects in Possession"
            value={summary?.in_possession?.count || 0}
            accent={C.green}
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <StatCircleCard
            icon={<CloseCircleOutlined />}
            label="Projects Not in Possession"
            value={summary?.not_in_possession?.count || 0}
            accent={C.orange}
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <StatCircleCard
            icon={<ExclamationCircleOutlined />}
            label="Overall Delayed Projects"
            value={summary?.overall_delayed_projects?.count || 0}
            accent={C.red}
          />
        </Col>
      </Row>

      {/* Donut Charts - KPI 2 & KPI 3 */}
      <Row gutter={[20, 20]} className="section-block" align="stretch">
        <Col xs={24} lg={12}>
          <PieLegendCard
            title="In-Possession Land — By Type"
            data={possessionTypeDonutData}
            total={possessionTypeTotal}
          />
        </Col>
        <Col xs={24} lg={12}>
          <PieLegendCard
            title="Not-in-Possession — Identification Status"
            data={idStatusDonutData}
            total={idStatusTotal}
          />
        </Col>
      </Row>

      {/* Most Feasible Land + Overall Portfolio Delay */}
      <Row gutter={[20, 20]} className="section-block" align="stretch">
        <Col xs={24} lg={12}>
          <Card className="chart-card" title="Most Feasible Land Identified — By Type">
            <div className="feasible-list">
              {feasibleTypeRows.map((r) => (
                <div className="mini-feasible-row" key={r.key}>
                  <span className="legend-dot" style={{ background: r.color }} />
                  <span className="mini-feasible-label">{r.label}</span>
                  <span className="mini-feasible-value" style={{ color: r.color }}>
                    {r.count} ({fmtPct(r.percentage)})
                  </span>
                </div>
              ))}
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card className="chart-card" title="Overall Portfolio Delay by Land Type">
            <div className="delay-table delay-table-compact">
              <div className="delay-table-header">
                <span>Land Type</span>
                <span>Avg. Delay (Days)</span>
                <span>On Time</span>
                <span>Delayed</span>
                <span>Critical</span>
              </div>
              {delayRows.map((r) => (
                <div className="delay-table-row" key={r.key}>
                  <span className="project-name">{r.label}</span>
                  <span className={r.avg_overall_delay_days > 0 ? "delay-days-bad" : "delay-days-good"}>
                    {r.avg_overall_delay_days}
                  </span>
                  <Tag color="success">{r.on_time_total?.count || 0}</Tag>
                  <Tag color="warning">{r.delayed_orange_total?.count || 0}</Tag>
                  <Tag color="error">{r.critical_red_total?.count || 0}</Tag>
                </div>
              ))}
            </div>
          </Card>
        </Col>
      </Row>

      {/* Stage Trackers - KPI 5 */}
      <Row gutter={[20, 20]} className="section-block">
        <Col xs={24}>
          <StageTracker title="Government Land Acquisition Progress (8-Stage)" stages={govtStages} />
        </Col>
      </Row>

      <Row gutter={[20, 20]} className="section-block" align="stretch">
        <Col xs={24} xl={12}>
          <StageTracker title="Private Land Acquisition Progress (6-Stage)" stages={privateStages} />
        </Col>
        <Col xs={24} xl={12}>
          <StageTracker title="MIDC Land Acquisition Progress (5-Stage)" stages={midcStages} />
        </Col>
      </Row>

      {/* KPI 7 - Milestone Delay Status Charts */}
      <Row gutter={[20, 20]} className="section-block" align="stretch">
        <Col xs={24} lg={8}>
          <HorizontalStackedBarCard
            title="Govt. Land — Milestone Delay Status"
            data={govtMilestoneData}
            bars={DELAY_BAR_DEFS}
            minRows={milestoneRowCount}
          />
        </Col>
        <Col xs={24} lg={8}>
          <HorizontalStackedBarCard
            title="MIDC Land — Milestone Delay Status"
            data={midcMilestoneData}
            bars={DELAY_BAR_DEFS}
            minRows={milestoneRowCount}
          />
        </Col>
        <Col xs={24} lg={8}>
          <HorizontalStackedBarCard
            title="Private Land — Milestone Delay Status"
            data={privateMilestoneData}
            bars={DELAY_BAR_DEFS}
            minRows={milestoneRowCount}
          />
        </Col>
      </Row>

      {/* KPI 9 - Pipeline Stage Analysis */}
      <Row gutter={[20, 20]} className="section-block" align="stretch">
        <Col xs={24} lg={8}>
          <HorizontalStackedBarCard
            title="Govt. Land — Pipeline Stage Analysis"
            data={govtPipelineData}
            bars={PIPELINE_BAR_DEFS}
            minRows={pipelineRowCount}
          />
        </Col>
        <Col xs={24} lg={8}>
          <HorizontalStackedBarCard
            title="MIDC Land — Pipeline Stage Analysis"
            data={midcPipelineData}
            bars={PIPELINE_BAR_DEFS}
            minRows={pipelineRowCount}
          />
        </Col>
        <Col xs={24} lg={8}>
          <HorizontalStackedBarCard
            title="Private Land — Pipeline Stage Analysis"
            data={privatePipelineData}
            bars={PIPELINE_BAR_DEFS}
            minRows={pipelineRowCount}
          />
        </Col>
      </Row>

      {/* ========== REPLACED Annual Area section with Delayed & Critical list ========== */}
      <Row gutter={[20, 20]} className="section-block">
        <Col xs={24}>
          <Card
            className="chart-card"
            title={
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
                <span className="card-title">Delayed & Critical Milestones</span>
                <Space size="middle">
                  <Tag color="error">Critical: {criticalCount}</Tag>
                  <Tag color="warning">Delayed: {delayedCount}</Tag>
                  <Tag>Total: {milestoneDelays.length}</Tag>
                </Space>
              </div>
            }
          >
            <Table
              rowKey={(r) => `${r.project_id}-${r.delayed_step}`}
              columns={delayColumns}
              dataSource={milestoneDelays}
              loading={delaysLoading}
              size="middle"
              // pagination={{
              //   pageSize: 10,
              //   showSizeChanger: true,
              //   showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} records`,
              // }}
              scroll={{ x: 1000 }}
              locale={{
                emptyText: delaysLoading ? "Loading..." : "No delayed or critical milestones found",
              }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;